import {
  useCancelPersonalizedStudyMutation,
  useDeletePersonalizedStudyMutation,
} from 'services/api/personalized';
import useStudyActions, {
  StudyActionsOptions,
  StudyActionTarget,
} from 'components/Flux/shared/useStudyActions';

// Flux Personalizado: previvaz-personalizado/delete + flux/kill-process, tag 'PersonalizedStudy'
export default function useStudyRowActions(
  study: StudyActionTarget,
  options: StudyActionsOptions = {},
) {
  const [triggerDelete, { isLoading: deleting }] = useDeletePersonalizedStudyMutation();
  const [triggerCancel, { isLoading: cancelling }] = useCancelPersonalizedStudyMutation();

  return useStudyActions(study, {
    triggerDelete, deleting, triggerCancel, cancelling, tag: 'PersonalizedStudy', ...options,
  });
}
